<template>
  <div id="locations-update">
    <wrld-container
      :breadcrumbs="this.breadcrumbs"
      :pageIsLoading="pageIsLoading"
    >
      <v-form
        ref="locationForm"
        v-model="valid"
        lazy-validation
      >
        <LocationForm v-model="location" :isUpdate="isUpdate"/>
        <v-btn class="mr-4" @click="goBack()">{{$t('buttons.cancel')}}</v-btn>
        <v-btn
          @click="callUpdateLocation()"
          :disabled="!valid"
        >{{$t('buttons.save')}}</v-btn>
        <span v-if="!valid" class="red--text">{{$t('general.not_all_required_fields')}}</span>
      </v-form>
    </wrld-container>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import router from '@/router'
import LocationForm from '@/components/locations/LocationForm.vue'

export default {
  name: 'LocationsUpdate',
  components: {
    LocationForm
  },
  data () {
    return {
      valid: true,
      location: {
        overview: {},
        address: {
          address: {},
          coordinates: {}
        },
        opening_hours: [],
        contacts: []
      },
      breadcrumbs: [
        { text: 'Wereldo', disabled: false, href: '#/' },
        { text: this.$i18n.tc('locations.location', 2), disabled: false, href: '#/locations' }
      ],
      isUpdate: false
    }
  },
  computed: {
    ...mapState(['route', 'locations'])
  },
  created () {
    this.fetchData()
  },
  methods: {
    ...mapActions({
      createLocation: 'createLocation',
      updateLocation: 'updateLocation',
      fetchLocations: 'fetchLocations',
      fetchLocationByID: 'fetchLocationByID',
      showSnackbar: 'showSnackbar'
    }),
    goBack () {
      router.push({ name: 'Locations' })
    },
    callUpdateLocation () {
      if (this.$refs['locationForm'].validate()) {
        let location = this.transformTmpLocation()
        // console.log(location)
        let snackMsg = ''
        let snackColor = ''
        if (this.route.params.locationID === undefined) {
          this.createLocation(location)
          if (this.locations.error) {
            snackMsg = this.$i18n.t('snackbars.error')
            snackColor = 'errorr'
          } else {
            snackMsg = this.$i18n.t('snackbars.location_created')
            snackColor = 'success'
          }
          this.showSnackbar({ message: snackMsg, color: snackColor })
          router.push({ name: 'Locations' })
        } else {
          this.updateLocation(location)
          if (this.locations.error) {
            snackMsg = this.$i18n.t('snackbars.error')
            snackColor = 'errorr'
          } else {
            snackMsg = this.$i18n.t('snackbars.location_updated')
            snackColor = 'success'
          }
          this.showSnackbar({ message: snackMsg, color: snackColor })
          router.push({
            name: 'LocationDetail',
            params: { locationID: this.route.params.locationID }
          })
        }
      }
    },
    transformTmpLocation () {
      let loc = this.location
      this.$set(loc, 'id', this.location.overview.id)
      // return this.location
      // let loc = this.tmpLocation
      let obj = {
        code: loc.overview.code,
        company: loc.overview.company,
        coordinates: {
          lat: Number(loc.address.coordinates.lat),
          lng: Number(loc.address.coordinates.lng)
        },
        address: {
          street: loc.address.address.street,
          street_number: loc.address.address.street_number,
          city: loc.address.address.city,
          country: loc.address.address.country,
          postal_code: loc.address.address.postal_code,
          country_code: loc.address.address.country_code
        },
        type: loc.overview.type,
        equipment: loc.overview.equipment,
        accessibility: '',
        groups: loc.groups,
        contacts: loc.contacts,
        opening_hours: loc.opening_hours
      }
      return obj
    },
    async fetchData () {
      this.pageIsLoading = true
      let locationID = this.route.params.locationID
      if (locationID != null) {
        if (this.locations.data[locationID] == null) {
          await this.fetchLocationByID(locationID)
        }
        this.fillData(this.locations.data[locationID])
        // this.location = this.locations.data[locationID]
        this.breadcrumbs.push({ text: `${this.location.overview.code}: ${this.$i18n.t('buttons.edit')}`, diabled: true })
        this.isUpdate = true
      } else {
        this.breadcrumbs.push({ text: this.$i18n.t('buttons.create'), diabled: true })
      }
      this.pageIsLoading = false
    },
    fillData (loc) {
      let overview = {
        code: loc.code,
        accessibility: loc.accessibility,
        company: loc.company,
        company_ref: loc.company_ref,
        company_vat: loc.company_vat,
        groups: loc.groups,
        id: loc.id,
        type: loc.type
      }
      let address = {
        address: {
          street: loc.address.street,
          city: loc.address.city,
          streetNo: loc.address.street_number,
          postalCode: loc.address.postal_code,
          countryCode: loc.address.country_code
        },
        coordinates: loc.coordinates
      }
      this.$set(this.location, 'overview', overview)
      this.$set(this.location, 'address', address)
      this.$set(this.location, 'opening_hours', loc.opening_hours)
      this.$set(this.location, 'contacts', loc.contacts)
    }
  }
}
</script>
